import {faCheckCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import React from 'react'
import {useNavigate} from 'react-router-dom'
import {Button} from 'react-daisyui'

interface MemberVerificationSuccessProps {
  onBackToSignIn?: () => void
}

const MemberVerificationSuccess: React.FC<MemberVerificationSuccessProps> = ({
  onBackToSignIn
}) => {
  const navigate = useNavigate()

  const handleBackToLogin = () => {
    if (onBackToSignIn) {
      onBackToSignIn()
    }
    navigate('/login')
  }

  return (
    <div className="grid grid-cols-1 gap-4">
      <div className="text-green-500 flex flex-col items-center p-2">
        <FontAwesomeIcon icon={faCheckCircle} className="text-8xl" />
      </div>
      <div>
        Your account has been successfully verified. You can now sign in with
        your email and password.
      </div>
      <Button
        type="submit"
        className="bg-cabana-500 btn-secondary disabled:text-white w-full"
        onClick={handleBackToLogin}
      >
        sign in
      </Button>
    </div>
  )
}

export default MemberVerificationSuccess
